import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";

export function useMarkContactChatRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (contactId: string) => {
      const response = await Contact.markChatRead(contactId);
      return response.data.data;
    },
    onSuccess: (_data, contactId) => {
      queryClient.invalidateQueries({
        queryKey: ["interactionCounts", contactId],
      });
    },
  });
}
